import { Component, OnInit } from '@angular/core';
import { MenuItem} from 'primeng/api';
import { Router } from '@angular/router';
import { RecentmessageService } from 'src/app/service/recentmessage.service';
import { RecentMessage } from 'src/app/interfaces/recentMessageData';
@Component({
  selector: 'app-recent-message-table',
  templateUrl: './recent-message-table.component.html',
  styleUrls: ['./recent-message-table.component.scss']
})
export class RecentMessageTableComponent implements OnInit {
  messagess: RecentMessage[] = [];
  items: MenuItem[] = [];
  constructor(private recentMessageService: RecentmessageService,private router:Router) { }
  ngOnInit(): void {
    this.recentMessageService.getRecentMessages().then(data => this.messagess = data);
    this.items = [{
      label: 'View',
      icon: 'pi pi-comment',
    },
    {
      label: 'Clone',
      icon: 'pi pi-files',
    },
    {
      label: 'View device',
      icon: 'pi pi-phone',
    },
    {
      label: 'Report issue',
      icon: 'pi pi-flag',
    },
    {
      label: 'View JSON API',
      icon: 'pi pi-eye',
    },
  ];
  }

  redirectConnect():void{
    this.router.navigate(['/connect'])
  }
  redirectChat():void{
    this.router.navigate(['/chat'])
  }
}
